<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-dialog width="1000px" :value="value" @input="toggleModal" persistent scrollable>
        <v-card class="kbLight">
            <v-toolbar :color="headerColor || 'kbPink'" dark text tabs>
                <div class="text-h6">{{ title || formatType }}</div>
                <v-spacer></v-spacer>
                <v-btn icon @click="toggleModal(false)">
                    <v-icon>clear</v-icon>
                </v-btn>

                <template slot="extension">
                    <v-tabs v-model="tabs"
                            centered
                            :background-color="headerColor || 'kbPink'"
                            slider-color="kbWhite">
                        <v-tab href="#correo">
                            {{ $t('general.emailOrPhone') }}
                        </v-tab>

                        <v-tab href="#csv">
                            {{ $t('general.loadCsv') }}
                        </v-tab>
                    </v-tabs>
                </template>
            </v-toolbar>

            <v-card-text class="pa-0">
                <v-tabs-items v-model="tabs">
                    <v-tab-item value="correo">
                        <v-card-text>
                            <v-form v-model="validForm" ref="inviteUserForm" lazy-validation @submit.prevent>
                                <v-row>
                                    <v-col cols="12">
                                        <v-chip color="kbDarkBlue"
                                                outlined
                                                close
                                                @click:close="removeUser(i)"
                                                v-for="(user, i) in arrayUsers"
                                                :key="i">{{user}}</v-chip>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field :label="$t('general.emailOrPhone')"
                                                      color="kbDarkBlue"
                                                      @keyup.188="addUser()"
                                                      @keyup.enter="addUser()"
                                                      @paste.prevent="pasteUsers"
                                                      v-model="formInviteUser.email"
                                                      :placeholder="$t('general.insertInvitedPeopleEmailPhone')">
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-card-text>
                    </v-tab-item>

                    <v-tab-item value="csv">
                        <v-container class="white">
                            <v-row>
                                <v-col cols="12">
                                    <v-textarea color="kbDarkBlue"
                                                solo
                                                v-model="message"
                                                :label="$t('general.message')"></v-textarea>
                                </v-col>
                            </v-row>
                        </v-container>

                        <v-data-table :headers="headers"
                                      class="ma-2 elevation-2"
                                      :items="invitations"
                                      :loading="loadingInvitations"
                                      :footer-props="{
                                        'items-per-page-text': `${$t('general.invitations')} ${$t('general.perPage')}`,
                                        'items-per-page-options': [50, 100, 200]
                                      }"
                                      :server-items-length="invitations.length"
                                      sort-by="">
                            <template v-slot:item.name="{ item }">
                              {{ item.name || $t('general.noName') }}
                            </template>
                            <template v-slot:item.name="{ item }">
                              {{ item.email || $t('general.noEmail') }}
                            </template>
                            <template v-slot:item.name="{ item }">
                              {{ item.phone || $t('general.noPhone') }}
                            </template>
                            <template v-slot:no-data>
                                <v-row>
                                    <v-col class="text-center" cols="12" v-if="loadingInvitations">
                                        {{ `${$t('general.loading')} ${$('general.invitations')}` }}
                                    </v-col>
                                    <v-col cols="12" class="red--text text-center" v-else>
                                        {{ $t('general.noLoadedInvitations') }}
                                    </v-col>
                                </v-row>
                            </template>
                        </v-data-table>
                    </v-tab-item>
                </v-tabs-items>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-btn @click="onPickFile"
                       color="kbPink"
                       dark
                       v-if="type === 'persona' && tabs === 'csv'">{{ $t('general.pickFile') }}</v-btn>
                <v-btn @click="downloadFormatCsv()"
                       color="kbPink"
                       outlined
                       v-if="type === 'persona' && tabs === 'csv'">{{ $t('general.downloadCsv') }}</v-btn>
                <input type="file" style="display: none" ref="fileInput" accept="*/*" @change="onFilePicked">
                <v-spacer></v-spacer>
                <v-btn color="red" outlined @click="closeInvite">{{$t('general.cancel')}}</v-btn>
                <v-btn :color="headerColor || 'kbPink'"
                       v-show="!submitDisabled"
                       dark
                       @click="submit()"
                       :loading="invitingUser">{{ $t('general.invite') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import csvParser from '@/libs/csvParser'
import rules from '@/libs/rules'
import notifications from '@/libs/notifications'
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      language: state => state.auth.language
    }),
    submitDisabled () {
      if (this.tabs === 'correo') return !this.arrayUsers.length > 0
      if (this.tabs === 'csv') return !this.invitations.length > 0
      return false
    },
    formatType () {
      if (this.type === 'persona') return this.$t('general.invitePerson')
      else if (this.type === 'administrador') return this.$t('general.inviteAdministrator')
      return ''
    }
  },
  data () {
    return {
      arrayUsers: [],
      invitingUser: false,
      formInviteUser: {
        email: ''
      },
      message: '',
      headers: [
        { text: this.$t('general.name'), value: 'name' },
        { text: 'Email', value: 'email' },
        { text: this.$t('general.phone'), value: 'phone' }
      ],
      loadingInvitations: false,
      invitations: [],
      validForm: true,
      rules: rules,
      tabs: 'correo'
    }
  },
  methods: {
    addUser () {
      let user = this.formInviteUser.email.replace(/(?:\r\n|,|\r|\n)/g, '')
      user = user.replace(/ /g, '')
      if (this.checkItem(user)) this.arrayUsers.push(user)
      this.formInviteUser.email = ''
    },
    downloadFormatCsv () {
      csvParser.downloadFormatCsv()
    },
    onPickFile () {
      this.$refs.fileInput.click()
    },
    onFilePicked (event) {
      const file = event.target.files[0]
      const filename = file.name
      if (filename.lastIndexOf('.') <= 0) {
        return window.alert(this.$t('general.pleaseAddAValidFile'))
      }

      if (file) {
        const reader = new FileReader()
        reader.readAsText(file, 'UTF-8')
        reader.onload = evt => {
          this.$set(this, 'invitations', csvParser.parseLocalFile(evt.target.result))
        }
        reader.onerror = function () {
          console.error(this.$t('general.errorReadingTheFile'))
        }
      }
    },
    pasteUsers (event) {
      let users = event.clipboardData.getData('Text').replace(/ /g, '')
      users = users.split(',')
      users = users.filter(item => {
        return this.checkItem(item)
      })

      this.arrayUsers = this.arrayUsers.concat(users)
    },
    removeUser (index) {
      this.arrayUsers.splice(index, 1)
    },
    checkItem (value) {
      const patternEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      const patternOnlyNumbers = /^[0-9]+$/
      return patternOnlyNumbers.test(value) || patternEmail.test(value)
    },
    closeInvite () {
      this.arrayUsers = []
      this.$refs.inviteUserForm.reset()
      this.$emit('input', false)
    },
    sendSms () {
      this.invitingUser = true
      const blob = new Blob([csvParser.unparseArray(this.invitations)])
      const file = new File([blob], 'invitations.csv', { type: 'text/csv' })
      this.$store.dispatch('uploadInvitationsFileAndSendSms', { message: this.message, file })
        .then(response => {
          this.invitingUser = false
          this.$store.dispatch('getInvitedUsers')
          notifications.success(response.message)
          this.toggleModal(false)
        })
        .catch(error => {
          this.invitingUser = false
          notifications.error(error.message)
        })
    },
    toggleModal (value) {
      this.invitations = []
      this.$emit('input', value)
    }
  },
  props: ['value', 'title', 'type', 'headerColor'],
  watch: {
    language () {
      this.headers[0].text = this.$t('general.name')
      this.headers[2].text = this.$t('general.phone')
    }
  }
}
</script>
